/**
 * 受注コード指定選定解除Input用VOクラス
 *
 * @export KYMW1318InputModel
 * @class KYMW1318InputModel
 */
export class KYMW1318InputModel {
  // 受注コード
  public orderCode = '';
  // Ｐコード
  public pCode = '';
  // 商品名
  public guideGoodsName = '';
  // 規格名
  public guideStandardName = '';
  // 媒体区分
  public mediumType = '';
  // 媒体区分リスト
  public mediumTypeList = [];

}